import React from "react";
import { useDispatch } from "react-redux";
import { alert } from "../../../../redux/slices/alertSlice";
import {
  Paper,
  Modal,
  Grid,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Cancel, FileCopy } from "@mui/icons-material";

export default function StyleModalConfirmation({
  styleModal,
  setStyleModal,
  agentId,
}) {
  const dispatch = useDispatch();
  function handleModalClose() {
    setStyleModal(false);
  }

  const text = `
  <!-- DolphinChat whatsapp widget -- >
  <script src="https://static.dolphinchat.ai/plugin/wa/js/wabot-1.0.js" async defer></script> 
  <div class="dolphinchat-app-${agentId}"></div>
  <!-- DolphinChat whatsapp widget ends-- >
`;

  const copyText = () => {
    navigator.clipboard.writeText(text);
    dispatch(alert({ type: "success", message: "Copied to clipboard." }));
  };

  return (
    <React.Fragment>
      <Modal
        open={styleModal}
        onClose={handleModalClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Paper
          style={{ padding: "30px", width: "400px", borderRadius: "20px" }}
          elevation={2}
        >
          <Cancel
            style={{
              marginLeft: "98%",
              color: "#cbcbcb",
              marginTop: "0px",
              cursor: "pointer",
            }}
            onClick={handleModalClose}
          />
          <Grid container spacing={3}>
            <Typography style={{ padding: "10px" }} variant="h4">
              Add the widget to your website
            </Typography>

            <Typography
              style={{ padding: "10px", color: "#808080" }}
              variant="h6"
            >
              To add the changes to your bot follow the required steps!
            </Typography>
            <Typography style={{ padding: "10px" }} variant="body1">
              <b> Step 1:</b> Copy the given script tag below in the box.
            </Typography>
            <Typography style={{ padding: "10px" }} variant="body1">
              <b>Step 2:</b> Paste the script tag in the head section of the
              code
            </Typography>
            <div
              style={{
                border: "1px solid #cbcbcb",
                margin: "5px",
              }}
            >
              <Grid
                style={{
                  padding: "10px 10px 0",
                  textAlign: "end",
                }}
                item
                xs={12}
              >
                <Tooltip title="copy text">
                  <IconButton
                    style={{ padding: "0px" }}
                    onClick={copyText}
                    color="primary"
                  >
                    <FileCopy />
                  </IconButton>
                </Tooltip>
              </Grid>
              <div style={{ padding: "10px 10px 0 10px" }}>
                <Typography style={{ padding: "0 0 10px 0" }} variant="body1">
                  {`<!-- DolphinChat whatsapp widget -- >`}
                </Typography>
                <Typography variant="body1">
                  {` <script src="https://static.dolphinchat.ai/plugin/wa/js/wabot-1.0.js" async defer></script> 
                   <div class="dolphinchat-app-${agentId}"></div>`}
                </Typography>
                <Typography
                  style={{ padding: "10px 0 10px 0" }}
                  variant="body1"
                >
                  {`<!-- DolphinChat whatsapp widget ends-- >`}
                </Typography>
              </div>
            </div>
          </Grid>
        </Paper>
      </Modal>
    </React.Fragment>
  );
}
